'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restoreSnapshottedActiveField = exports.restoreSnapshottedField = exports.restoreSnapshot = exports.snapshotActiveField = exports.createSnapshot = exports.createOrRestoreFieldSnapshot = undefined;
var _constants = require('../constants');
var _activeField = require('../selectors/active-field');
var _fieldInfo = require('../selectors/field-info');
var _snapshot = require('../utils/snapshot');
var _updateForm = require('./update-form');
var _updateFields = require('./update-fields');
var _validation = require('./validation');

// Snapshot or restore a single field saving value and error
var createOrRestoreFieldSnapshot = exports.createOrRestoreFieldSnapshot = function createOrRestoreFieldSnapshot(formId, namedField) {
  var restore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch, getState) {
    var original = restore ? (0, _snapshot.getSnapshotFormId)(formId) : formId;
    var target = restore ? formId : (0, _snapshot.getSnapshotFormId)(formId);
    dispatch((0, _updateFields.setValue)(target, namedField, (0, _fieldInfo.getValue)(getState(), original, namedField)));
    dispatch((0, _validation.validateFieldAction)(target, namedField, (0, _fieldInfo.getError)(getState(), original, namedField)));
  };
};

// Create a snapshot of existing form state
// Alternatively provide a namedField to update just that field (including error)
var createSnapshot = exports.createSnapshot = function createSnapshot(formId, namedField) {
  return function (dispatch, getState) {
    if (typeof namedField !== 'undefined') {
      return dispatch(createOrRestoreFieldSnapshot(formId, namedField));
    }
    return dispatch({
      type: _constants.actionTypes.CREATE_SNAPSHOT,
      formId: formId
    });
  };
};

// Create a snapshot updating just activeField
var snapshotActiveField = exports.snapshotActiveField = function snapshotActiveField(formId) {
  return function (dispatch, getState) {
    return dispatch(createSnapshot(formId, (0, _activeField.getActiveField)(getState(), formId)));
  };
};

// Restore form to snapshot using form reset
var restoreSnapshot = exports.restoreSnapshot = function restoreSnapshot(formId) {
  return (0, _updateForm.resetForm)(formId, true);
};

// Restore a field from snapshot
var restoreSnapshottedField = exports.restoreSnapshottedField = function restoreSnapshottedField(formId, namedField) {
  return function (dispatch, getState) {
    return dispatch(createOrRestoreFieldSnapshot(formId, namedField, true));
  };
};

// Restore snapshot of activeField
var restoreSnapshottedActiveField = exports.restoreSnapshottedActiveField = function restoreSnapshottedActiveField(formId) {
  return function (dispatch, getState) {
    return dispatch(restoreSnapshottedField(formId, (0, _activeField.getActiveField)(getState(), formId)));
  };
};